export const PLATFORM_THEME_COLORS_SETTING_KEY = 'platformThemeColors'
export const PLATFORM_THEME_COLORS_CHANGE_EVENT = 'platform-theme-colors-change'

export const PLATFORM_THEME_COLOR_GROUPS = [
  {
    title: 'Основные цвета и кнопки',
    colors: [
      ['--color-accent', 'Основной цвет'],
      ['--color-accent-bright', 'Яркий акцент'],
      ['--color-accent-vivid', 'Насыщенный акцент'],
      ['--color-accent-first', 'Дополнительный акцент 1'],
      ['--color-accent-second', 'Дополнительный акцент 2'],
      ['--color-on-accent', 'Текст на акцентном фоне'],
      ['--color-light-btn', 'Светлая кнопка'],
      ['--color-accent-btn', 'Акцентная светлая кнопка'],
      ['--color-button-primary-bg', 'Основная кнопка'],
      ['--color-button-primary-hover-bg', 'Основная кнопка при наведении'],
      ['--color-button-primary-text', 'Текст основной кнопки'],
      [
        '--color-button-primary-hover-text',
        'Текст основной кнопки при наведении',
      ],
      [
        '--color-button-primary-active-text',
        'Текст основной кнопки при нажатии',
      ],
      ['--color-button-accent-alt-bg', 'Альтернативная акцентная кнопка'],
      ['--color-button-accent-deep-bg', 'Тёмная акцентная кнопка'],
      ['--color-button-accent-muted-bg', 'Приглушённая акцентная кнопка'],
      [
        '--color-button-accent-muted-text',
        'Текст приглушённой акцентной кнопки',
      ],
      [
        '--color-button-accent-translucent-border',
        'Полупрозрачная акцентная граница',
      ],
      ['--color-button-accent-soft-bg', 'Мягкая акцентная кнопка'],
      ['--color-button-pink-bg', 'Розовая кнопка'],
      ['--color-button-secondary-bg', 'Дополнительная кнопка'],
      ['--color-button-secondary-soft-bg', 'Светлая дополнительная кнопка'],
      [
        '--color-button-secondary-hover-bg',
        'Дополнительная кнопка при наведении',
      ],
      [
        '--color-button-secondary-pressed-bg',
        'Дополнительная кнопка при нажатии',
      ],
      ['--color-button-secondary-text', 'Текст дополнительной кнопки'],
      ['--color-button-neutral-bg', 'Нейтральная кнопка'],
      ['--color-button-neutral-hover-bg', 'Нейтральная кнопка при наведении'],
      ['--color-button-neutral-text', 'Текст нейтральной кнопки'],
      ['--color-button-strong-text', 'Контрастный текст кнопки'],
      ['--color-button-muted-bg', 'Приглушённая кнопка'],
      ['--color-button-cool-muted-bg', 'Холодная приглушённая кнопка'],
      ['--color-button-neutral-pressed-bg', 'Нейтральная кнопка при нажатии'],
      ['--color-button-border', 'Граница кнопки'],
      ['--color-button-border-soft', 'Мягкая граница кнопки'],
      ['--color-button-border-strong', 'Контрастная граница кнопки'],
      ['--color-button-border-contrast', 'Тёмная граница кнопки'],
      ['--color-button-border-hover', 'Граница кнопки при наведении'],
      ['--color-button-lavender-border', 'Лавандовая граница кнопки'],
      ['--color-button-neutral-subtle-bg', 'Мягкая нейтральная кнопка'],
      ['--color-button-disabled-bg', 'Неактивная кнопка'],
      ['--color-button-disabled-strong-bg', 'Контрастная неактивная кнопка'],
      ['--color-button-disabled-text', 'Текст неактивной кнопки'],
      ['--color-button-icon-muted', 'Приглушённая иконка кнопки'],
      ['--color-button-icon-muted-hover', 'Приглушённая иконка при наведении'],
      ['--color-button-icon-disabled-soft', 'Светлая неактивная иконка'],
      ['--color-button-danger-bg', 'Кнопка опасного действия'],
      ['--color-button-danger-hover-bg', 'Опасная кнопка при наведении'],
      ['--color-button-danger-soft-bg', 'Мягкая опасная кнопка'],
      ['--color-button-danger-text', 'Текст опасной кнопки'],
      [
        '--color-button-danger-hover-text',
        'Текст опасной кнопки при наведении',
      ],
      ['--color-button-danger-strong-bg', 'Контрастная опасная кнопка'],
      [
        '--color-button-danger-strong-hover-bg',
        'Контрастная опасная кнопка при наведении',
      ],
      ['--color-button-danger-legacy-bg', 'Опасная кнопка legacy'],
      [
        '--color-button-danger-legacy-hover-bg',
        'Опасная кнопка legacy при наведении',
      ],
      ['--color-button-success-bg', 'Кнопка успешного действия'],
      ['--color-button-success-muted-bg', 'Приглушённая кнопка успеха'],
      ['--color-button-info-bg', 'Информационная кнопка'],
      ['--color-button-link-bg', 'Кнопка-ссылка'],
      ['--color-button-link-text', 'Текст кнопки-ссылки'],
      ['--color-button-overlay-bg', 'Кнопка поверх контента'],
      ['--color-button-vk-accent', 'Акцент кнопки VK'],
      ['--color-button-warning-bg', 'Предупреждающая кнопка'],
      [
        '--color-button-warning-hover-bg',
        'Предупреждающая кнопка при наведении',
      ],
      ['--color-button-warning-text', 'Текст предупреждающей кнопки'],
      ['--color-button-focus-ring', 'Обводка кнопки в фокусе'],
      ['--color-lavender-soft', 'Светлый лавандовый фон'],
      ['--color-violet', 'Фиолетовый'],
      ['--color-violet-dark', 'Тёмный фиолетовый'],
      ['--color-yellow', 'Жёлтая кнопка'],
      ['--color-red', 'Красная кнопка'],
    ],
  },
  {
    title: 'Текст',
    colors: [
      ['--color-text-main', 'Основной текст'],
      ['--color-text-secondary', 'Дополнительный текст'],
      ['--color-text-muted', 'Приглушённый текст'],
      ['--color-text-strong', 'Контрастный основной текст'],
      ['--color-text-strong-secondary', 'Контрастный дополнительный текст'],
      ['--color-text-neutral', 'Нейтральный текст'],
      ['--color-text-neutral-soft', 'Мягкий нейтральный текст'],
      ['--color-text-soft', 'Светлый текст'],
      ['--color-text-gray', 'Серый текст'],
      ['--color-text-placeholder', 'Текст подсказок'],
      ['--color-text-disabled', 'Неактивный текст'],
      ['--color-text-pale', 'Светлый дополнительный текст'],
      ['--color-text-faint', 'Едва заметный текст'],
      ['--color-text-dimmed', 'Затемнённый текст'],
      ['--color-text-translucent', 'Полупрозрачный текст'],
      ['--color-text-inverse-soft', 'Светлый текст на тёмном фоне'],
      ['--color-text-on-accent-muted', 'Приглушённый текст на акценте'],
      ['--color-text-accent', 'Акцентный текст'],
      ['--color-text-accent-strong', 'Контрастный акцентный текст'],
      ['--color-text-accent-muted', 'Полупрозрачный акцентный текст'],
      ['--color-text-info', 'Информационный текст'],
      ['--color-text-success', 'Текст успешного состояния'],
      ['--color-text-danger', 'Текст ошибки'],
      ['--color-text-warning', 'Текст предупреждения'],
      ['--color-text-lavel-status', 'Подписи и статусы'],
      ['--color-text-lavel', 'Заголовки и подписи'],
      ['--text-active', 'Активный текст'],
      ['--color-black', 'Контрастный текст'],
      ['--color-dark', 'Тёмный текст'],
      ['--color-gray', 'Серый текст'],
      ['--color-time', 'Текст времени'],
      ['--color-link-blue', 'Ссылки'],
    ],
  },
  {
    title: 'Фоны и поверхности',
    colors: [
      ['--color-page-bg', 'Фон страницы'],
      ['--color-surface', 'Основная поверхность'],
      ['--color-surface-soft', 'Дополнительная поверхность'],
      ['--color-surface-subtle', 'Едва заметная поверхность'],
      ['--color-surface-muted', 'Приглушённая поверхность'],
      ['--color-surface-panel', 'Фон панелей'],
      ['--color-surface-cool', 'Холодная поверхность'],
      ['--color-surface-cool-soft', 'Мягкая холодная поверхность'],
      ['--color-surface-accent', 'Акцентная поверхность'],
      ['--color-surface-accent-soft', 'Мягкая акцентная поверхность'],
      ['--color-surface-accent-muted', 'Приглушённая акцентная поверхность'],
      ['--color-surface-table-accent', 'Акцентный фон таблиц'],
      ['--color-surface-canvas', 'Фон рабочей области'],
      ['--color-surface-deep', 'Углублённая поверхность'],
      ['--color-surface-deepest', 'Глубокая поверхность'],
      ['--color-surface-auth', 'Фон страниц авторизации'],
      ['--color-surface-overlay', 'Плотная полупрозрачная подложка'],
      ['--color-surface-overlay-soft', 'Мягкая полупрозрачная подложка'],
      ['--color-surface-image-scrim', 'Затемнение поверх изображения'],
      ['--color-surface-backdrop', 'Затемнение за модальным окном'],
      ['--color-surface-backdrop-soft', 'Мягкое затемнение'],
      ['--color-white', 'Белая поверхность'],
      ['--color-smoke', 'Дымчатый фон'],
      ['--color-blue-gray', 'Серо-синий фон'],
      ['--color-light-grey-nd', 'Светло-серый фон'],
      ['--color-mid-grey-nd', 'Средне-серый фон'],
      ['--color-grey-nd', 'Серый фон'],
    ],
  },
  {
    title: 'Границы и состояния',
    colors: [
      ['--color-light-stroke', 'Основная граница'],
      ['--color-border-neutral', 'Нейтральная граница'],
      ['--color-stroke-hover', 'Граница при наведении'],
      ['--color-border-soft', 'Мягкая граница'],
      ['--color-border-subtle', 'Светлая граница'],
      ['--color-border-muted', 'Приглушённая граница'],
      ['--color-border-strong', 'Контрастная граница'],
      ['--color-border-accent', 'Акцентная граница'],
      ['--color-border-accent-strong', 'Контрастная акцентная граница'],
      ['--color-border-accent-deep', 'Тёмная акцентная граница'],
      ['--color-border-purple-muted', 'Приглушённая фиолетовая граница'],
      ['--color-border-cool', 'Холодная граница'],
      ['--color-border-inverse', 'Граница на контрастном фоне'],
      ['--color-divider', 'Разделитель'],
      ['--color-shadow-soft', 'Цвет мягкой тени'],
      ['--color-shadow-medium', 'Цвет средней тени'],
      ['--color-shadow-strong', 'Цвет контрастной тени'],
      ['--color-shadow-accent', 'Цвет акцентной тени'],
      ['--color-shadow-inverse', 'Светлая контрастная тень'],
      ['--color-green', 'Зелёный'],
      ['--color-success', 'Успешное действие'],
      ['--color-success-soft', 'Фон успешного действия'],
      ['--color-danger', 'Ошибка'],
      ['--color-danger-soft', 'Фон ошибки'],
      ['--color-status-success', 'Статус успеха'],
      ['--color-status-success-bg', 'Фон статуса успеха'],
      ['--color-status-success-border', 'Граница статуса успеха'],
      ['--color-status-success-text', 'Текст статуса успеха'],
      ['--color-status-danger', 'Статус ошибки'],
      ['--color-status-danger-bg', 'Фон статуса ошибки'],
      ['--color-status-danger-border', 'Граница статуса ошибки'],
      ['--color-status-danger-text', 'Текст статуса ошибки'],
      ['--color-status-warning', 'Статус предупреждения'],
      ['--color-status-warning-bg', 'Фон предупреждения'],
      ['--color-status-warning-border', 'Граница предупреждения'],
      ['--color-status-warning-text', 'Текст предупреждения'],
      ['--color-status-info-bg', 'Фон информационного статуса'],
      ['--color-status-info-border', 'Граница информационного статуса'],
      ['--color-status-info-text', 'Текст информационного статуса'],
      ['--color-status-neutral-bg', 'Фон нейтрального статуса'],
      [
        '--color-status-neutral-strong-bg',
        'Контрастный фон нейтрального статуса',
      ],
      ['--color-status-neutral-text', 'Текст нейтрального статуса'],
      ['--color-green-deep', 'Насыщенный зелёный'],
      ['--color-yellow-deep', 'Насыщенный жёлтый'],
      ['--color-blue-deep', 'Насыщенный синий'],
      ['--color-pink-deep', 'Насыщенный розовый'],
    ],
  },
  {
    title: 'Служебные цвета',
    colors: [
      ['--color-flag-blue', 'Синий флага'],
      ['--color-flag-red', 'Красный флага'],
      ['--color-excel-gray', 'Excel: серый'],
      ['--color-excel-green-light', 'Excel: светло-зелёный'],
      ['--color-excel-green', 'Excel: зелёный'],
      ['--color-excel-green-dark', 'Excel: тёмно-зелёный'],
      ['--color-excel-green-bg', 'Excel: фон'],
      ['--color-brand-orange', 'Фирменный оранжевый'],
    ],
  },
  {
    title: 'Трекер задач',
    colors: [
      ['--task-tracker-surface-muted', 'Приглушённая поверхность'],
      ['--task-tracker-surface-overlay', 'Подложка'],
      ['--task-tracker-surface-overlay-soft', 'Светлая подложка'],
      ['--task-tracker-accent-overlay', 'Акцентная подложка'],
      ['--task-tracker-border-accent', 'Акцентная граница'],
      ['--task-tracker-text-muted', 'Приглушённый текст'],
      ['--task-tracker-danger', 'Ошибка'],
      ['--task-tracker-danger-bg', 'Фон ошибки'],
      ['--task-tracker-danger-border', 'Граница ошибки'],
      ['--task-tracker-warning', 'Предупреждение'],
      ['--task-tracker-warning-bg', 'Фон предупреждения'],
      ['--task-tracker-warning-border', 'Граница предупреждения'],
      ['--task-tracker-info-bg', 'Информационный фон'],
      ['--task-tracker-info', 'Информационный цвет'],
    ],
  },
  {
    title: 'Поля и элементы выбора',
    colors: [
      ['--color-control-bg', 'Фон поля'],
      ['--color-control-bg-hover', 'Фон поля при наведении'],
      ['--color-control-bg-disabled', 'Фон неактивного поля'],
      ['--color-control-bg-accent', 'Акцентный фон поля'],
      ['--color-control-bg-accent-strong', 'Контрастный акцентный фон поля'],
      ['--color-control-border', 'Граница поля'],
      ['--color-control-border-hover', 'Граница поля при наведении'],
      ['--color-control-border-focus', 'Граница поля в фокусе'],
      ['--color-control-border-info', 'Информационная граница поля'],
      [
        '--color-control-border-info-hover',
        'Информационная граница при наведении',
      ],
      ['--color-control-border-focus-alt', 'Дополнительная граница в фокусе'],
      ['--color-control-border-disabled', 'Граница неактивного поля'],
      ['--color-control-text', 'Текст поля'],
      ['--color-control-placeholder', 'Подсказка в поле'],
      ['--color-control-check-bg', 'Фон выбранного чекбокса'],
      ['--color-control-check-info-bg', 'Информационный фон чекбокса'],
      ['--color-control-accent-deep', 'Тёмный акцент элемента выбора'],
      ['--color-control-accent-hover', 'Акцент элемента выбора при наведении'],
      ['--color-control-check-mark', 'Метка выбранного чекбокса'],
      ['--color-control-focus-ring', 'Обводка поля в фокусе'],
      ['--color-control-selection-bg', 'Фон выбранного элемента'],
      [
        '--color-control-selection-strong-bg',
        'Контрастный фон выбранного элемента',
      ],
    ],
  },
  {
    title: 'Иконки и SVG',
    colors: [
      ['--color-icon-main', 'Основные иконки'],
      ['--color-icon-secondary', 'Дополнительные иконки'],
      ['--color-icon-muted', 'Приглушённые иконки'],
      ['--color-icon-faint', 'Светлые иконки'],
      ['--color-icon-accent', 'Акцентные иконки'],
      ['--color-icon-accent-strong', 'Контрастные акцентные иконки'],
      ['--color-icon-inverse', 'Иконки на контрастном фоне'],
      ['--color-icon-info', 'Информационные иконки'],
      ['--color-icon-bg', 'Фон иконок'],
      ['--color-icon-surface', 'Внутренняя поверхность SVG'],
      ['--color-icon-border', 'Внутренняя граница SVG'],
      ['--color-icon-detail', 'Детали SVG'],
      ['--color-icon-detail-muted', 'Приглушённые детали SVG'],
      ['--color-icon-detail-soft', 'Светлые детали SVG'],
      ['--color-icon-strong', 'Контрастные детали SVG'],
      ['--color-icon-accent-alt', 'Дополнительный акцент SVG'],
    ],
  },
]

const LIGHT_THEME_COLORS = {
  '--color-accent': '#6e368c',
  '--color-accent-bright': '#ab48e0',
  '--color-accent-vivid': '#9747ff',
  '--color-accent-first': '#ed6b69',
  '--color-accent-second': '#287abe',
  '--color-blue-gray': '#e6ecf2',
  '--color-gray': '#a3a3a5',
  '--text-active': '#11142d',
  '--color-white': '#ffffff',
  '--color-on-accent': '#ffffff',
  '--color-black': '#000000',
  '--color-dark': '#3a3938',
  '--color-smoke': '#f6f6f6',
  '--color-yellow': '#fcc246',
  '--color-green': '#138e1f',
  '--color-success': '#52c41a',
  '--color-success-soft': '#c7f3be',
  '--color-danger': '#ff4d4f',
  '--color-danger-soft': '#ffccc7',
  '--color-status-success': '#52c41a',
  '--color-status-success-bg': '#edf9f1',
  '--color-status-success-border': '#b5e5c2',
  '--color-status-success-text': '#127a38',
  '--color-status-danger': '#ff4d4f',
  '--color-status-danger-bg': '#fff2f0',
  '--color-status-danger-border': '#ffccc7',
  '--color-status-danger-text': '#cf1322',
  '--color-status-warning': '#f5aa31',
  '--color-status-warning-bg': '#fff8ea',
  '--color-status-warning-border': '#f2d7a8',
  '--color-status-warning-text': '#b45309',
  '--color-status-info-bg': '#eef3ff',
  '--color-status-info-border': '#c9d0dc',
  '--color-status-info-text': '#2563eb',
  '--color-status-neutral-bg': '#ededed',
  '--color-status-neutral-strong-bg': '#2e2e2e',
  '--color-status-neutral-text': '#64748b',
  '--color-light-grey-nd': '#fafafb',
  '--color-mid-grey-nd': '#fbfbfb',
  '--color-grey-nd': '#f7f7f7',
  '--color-light-stroke': '#ebebeb',
  '--color-border-neutral': '#d9d9d9',
  '--color-stroke-hover': '#ede0ff',
  '--color-border-soft': '#f4f4f4',
  '--color-border-subtle': '#e7e7e8',
  '--color-border-muted': '#e2dfdf',
  '--color-border-strong': '#bdbdbd',
  '--color-border-accent': '#e2d4e9',
  '--color-border-accent-strong': '#9747ff',
  '--color-border-accent-deep': '#835499',
  '--color-border-purple-muted': '#aaa9ba',
  '--color-border-cool': '#dde0ea',
  '--color-border-inverse': '#ffffff',
  '--color-divider': '#2b2d3e14',
  '--color-shadow-soft': '#2b2d3e14',
  '--color-shadow-medium': '#00000040',
  '--color-shadow-strong': '#00000066',
  '--color-shadow-accent': '#9747ff1f',
  '--color-shadow-inverse': '#ffffff80',
  '--color-control-bg': '#ffffff',
  '--color-control-bg-hover': '#fafafa',
  '--color-control-bg-disabled': '#f3f3f3',
  '--color-control-bg-accent': '#f9edff',
  '--color-control-bg-accent-strong': '#e8bbff',
  '--color-control-border': '#d9d9d9',
  '--color-control-border-hover': '#bdbdbd',
  '--color-control-border-focus': '#9747ff',
  '--color-control-border-info': '#4096ff',
  '--color-control-border-info-hover': '#69b1ff',
  '--color-control-border-focus-alt': '#8b5cf6',
  '--color-control-border-disabled': '#e2dfdf',
  '--color-control-text': '#2b2d3e',
  '--color-control-placeholder': '#a3a3a3',
  '--color-control-check-bg': '#9747ff',
  '--color-control-check-info-bg': '#4f80ff',
  '--color-control-accent-deep': '#6e368c',
  '--color-control-accent-hover': '#ab48e0',
  '--color-control-check-mark': '#ffffff',
  '--color-control-focus-ring': '#9747ff1f',
  '--color-control-selection-bg': '#f0e6f6',
  '--color-control-selection-strong-bg': '#e2d3e9',
  '--color-icon-main': '#2b2d3e',
  '--color-icon-secondary': '#858585',
  '--color-icon-muted': '#c5c6d9',
  '--color-icon-faint': '#b59fc2',
  '--color-icon-accent': '#9747ff',
  '--color-icon-accent-strong': '#6e368c',
  '--color-icon-inverse': '#ffffff',
  '--color-icon-info': '#426ad1',
  '--color-icon-bg': '#f8f8fb',
  '--color-icon-surface': '#ffffff',
  '--color-icon-border': '#d9d9e3',
  '--color-icon-detail': '#d7d9e2',
  '--color-icon-detail-muted': '#e9e9ee',
  '--color-icon-detail-soft': '#f6f6f9',
  '--color-icon-strong': '#8d8da3',
  '--color-icon-accent-alt': '#8b5cf6',
  '--color-lavender-soft': '#f9edff',
  '--color-light-btn': '#fbf4ff',
  '--color-accent-btn': '#f6e5ff',
  '--color-button-primary-bg': '#9747ff',
  '--color-button-primary-hover-bg': '#ab48e0',
  '--color-button-primary-text': '#ffffff',
  '--color-button-primary-hover-text': '#fcc246',
  '--color-button-primary-active-text': '#000000',
  '--color-button-accent-alt-bg': '#9a41ca',
  '--color-button-accent-deep-bg': '#7d3bea',
  '--color-button-accent-muted-bg': '#a5a6f6',
  '--color-button-accent-muted-text': '#000000',
  '--color-button-accent-translucent-border': '#9683d742',
  '--color-button-accent-soft-bg': '#f0e6f6',
  '--color-button-pink-bg': '#f0baeb',
  '--color-button-secondary-bg': '#f9edff',
  '--color-button-secondary-soft-bg': '#fbf4ff',
  '--color-button-secondary-hover-bg': '#f6e5ff',
  '--color-button-secondary-pressed-bg': '#d9c7e3',
  '--color-button-secondary-text': '#2b2d3e',
  '--color-button-neutral-bg': '#ffffff',
  '--color-button-neutral-hover-bg': '#f8f8f8',
  '--color-button-neutral-text': '#2b2d3e',
  '--color-button-strong-text': '#000000',
  '--color-button-muted-bg': '#ebebeb',
  '--color-button-cool-muted-bg': '#e2e8f0',
  '--color-button-neutral-pressed-bg': '#dddcdd',
  '--color-button-border': '#dedede',
  '--color-button-border-soft': '#d9d9d9',
  '--color-button-border-strong': '#c9c9c9',
  '--color-button-border-contrast': '#bdbdbd',
  '--color-button-border-hover': '#e2d4e9',
  '--color-button-lavender-border': '#d8c7ff',
  '--color-button-neutral-subtle-bg': '#f4f4f4',
  '--color-button-disabled-bg': '#f4f2f2',
  '--color-button-disabled-strong-bg': '#dedede',
  '--color-button-disabled-text': '#b7b7b7',
  '--color-button-icon-muted': '#c5c6d9',
  '--color-button-icon-muted-hover': '#b2adb5',
  '--color-button-icon-disabled-soft': '#dadada',
  '--color-button-danger-bg': '#ed6b69',
  '--color-button-danger-hover-bg': '#ff7875',
  '--color-button-danger-soft-bg': '#ffb2b4',
  '--color-button-danger-text': '#ffffff',
  '--color-button-danger-hover-text': '#000000',
  '--color-button-danger-strong-bg': '#e53935',
  '--color-button-danger-strong-hover-bg': '#d32f2f',
  '--color-button-danger-legacy-bg': '#d9534f',
  '--color-button-danger-legacy-hover-bg': '#dc3545',
  '--color-button-success-bg': '#4caf50',
  '--color-button-success-muted-bg': '#31a35c',
  '--color-button-info-bg': '#2196f3',
  '--color-button-link-bg': '#3156d3',
  '--color-button-link-text': '#ffffff',
  '--color-button-overlay-bg': '#ffffffeb',
  '--color-button-vk-accent': '#0077ff',
  '--color-button-warning-bg': '#fcc246',
  '--color-button-warning-hover-bg': '#ffd166',
  '--color-button-warning-text': '#000000',
  '--color-button-focus-ring': '#6e368c',
  '--color-text-main': '#2b2d3e',
  '--color-text-secondary': '#423b46',
  '--color-text-muted': '#64748b',
  '--color-text-strong': '#111827',
  '--color-text-strong-secondary': '#334155',
  '--color-text-neutral': '#5d5d5d',
  '--color-text-neutral-soft': '#6f7180',
  '--color-text-soft': '#8c8c8c',
  '--color-text-gray': '#808080',
  '--color-text-placeholder': '#a3a3a3',
  '--color-text-disabled': '#b7b7b7',
  '--color-text-pale': '#cbd5e1',
  '--color-text-faint': '#2b2d3e3f',
  '--color-text-dimmed': '#2b2d3e80',
  '--color-text-translucent': '#2b2d3eb3',
  '--color-text-inverse-soft': '#eef3ff',
  '--color-text-on-accent-muted': '#ffffffb6',
  '--color-text-accent': '#9a41ca',
  '--color-text-accent-strong': '#7d3bea',
  '--color-text-accent-muted': '#9747ff8c',
  '--color-text-info': '#2563eb',
  '--color-text-success': '#127a38',
  '--color-text-danger': '#cf1322',
  '--color-text-warning': '#b45309',
  '--color-text-lavel-status': '#aaabc0',
  '--color-text-lavel': '#2b3674',
  '--color-violet': '#ae9be4',
  '--color-violet-dark': '#9a82dd',
  '--color-time': '#b59fc2',
  '--color-red': '#ee7a45',
  '--color-green-deep': '#4bb042',
  '--color-yellow-deep': '#feca06',
  '--color-blue-deep': '#0cc1f3',
  '--color-pink-deep': '#ee347d',
  '--color-link-blue': '#1677ff',
  '--color-flag-blue': '#41479b',
  '--color-flag-red': '#ff4b55',
  '--color-excel-gray': '#9d9c9b',
  '--color-excel-green-light': '#69c997',
  '--color-excel-green': '#54ad7d',
  '--color-excel-green-dark': '#2b593d',
  '--color-excel-green-bg': '#3d8a58',
  '--color-brand-orange': '#ff691e',
  '--color-page-bg': '#fcfcfc',
  '--color-surface': '#ffffff',
  '--color-surface-soft': '#f8f8f8',
  '--color-surface-subtle': '#fafafa',
  '--color-surface-muted': '#f4f4f4',
  '--color-surface-panel': '#f5f5f5',
  '--color-surface-cool': '#e2e8f0',
  '--color-surface-cool-soft': '#eef1f5',
  '--color-surface-accent': '#f9edff',
  '--color-surface-accent-soft': '#fbf4ff',
  '--color-surface-accent-muted': '#f0e6f6',
  '--color-surface-table-accent': '#fcf6ff',
  '--color-surface-canvas': '#fbfcff',
  '--color-surface-deep': '#ffffff',
  '--color-surface-deepest': '#f7f7f7',
  '--color-surface-auth': '#ffffff',
  '--color-surface-overlay': '#ffffffe6',
  '--color-surface-overlay-soft': '#ffffff8c',
  '--color-surface-image-scrim': '#020a0c6b',
  '--color-surface-backdrop': '#2b2d3e94',
  '--color-surface-backdrop-soft': '#2b2d3e73',
  '--task-tracker-surface-muted': '#fdfaff',
  '--task-tracker-surface-overlay': '#ffffffe6',
  '--task-tracker-surface-overlay-soft': '#ffffff8c',
  '--task-tracker-accent-overlay': '#9747ff14',
  '--task-tracker-border-accent': '#c9a8ff',
  '--task-tracker-text-muted': '#8c7a9e',
  '--task-tracker-danger': '#d4380d',
  '--task-tracker-danger-bg': '#fff7f7',
  '--task-tracker-danger-border': '#f0c4c4',
  '--task-tracker-warning': '#d46b08',
  '--task-tracker-warning-bg': '#fff7e6',
  '--task-tracker-warning-border': '#ffd591',
  '--task-tracker-info-bg': '#e6f4ff',
  '--task-tracker-info': '#1677ff',
}

const DARK_THEME_OVERRIDES = {
  '--color-blue-gray': '#283044',
  '--color-gray': '#94a3b8',
  '--text-active': '#f4f6fb',
  '--color-white': '#171b26',
  '--color-black': '#f6f7fb',
  '--color-dark': '#eef1f7',
  '--color-smoke': '#111520',
  '--color-success-soft': '#4bb0422e',
  '--color-danger': '#ff7875',
  '--color-danger-soft': '#ff78752e',
  '--color-status-success': '#4ade80',
  '--color-status-success-bg': '#163a2a',
  '--color-status-success-border': '#2f6f4d',
  '--color-status-success-text': '#4ade80',
  '--color-status-danger': '#ff7875',
  '--color-status-danger-bg': '#3b2025',
  '--color-status-danger-border': '#6b353a',
  '--color-status-danger-text': '#f87171',
  '--color-status-warning': '#fcd34d',
  '--color-status-warning-bg': '#3a2f1f',
  '--color-status-warning-border': '#6a552d',
  '--color-status-warning-text': '#fbbf24',
  '--color-status-info-bg': '#1d2c4a',
  '--color-status-info-border': '#36517d',
  '--color-status-info-text': '#60a5fa',
  '--color-status-neutral-bg': '#252c3e',
  '--color-status-neutral-strong-bg': '#596579',
  '--color-status-neutral-text': '#94a3b8',
  '--color-light-grey-nd': '#151a25',
  '--color-mid-grey-nd': '#171c28',
  '--color-grey-nd': '#1c2230',
  '--color-light-stroke': '#2b3346',
  '--color-border-neutral': '#3d465b',
  '--color-stroke-hover': '#3d465b',
  '--color-border-soft': '#252c3e',
  '--color-border-subtle': '#2b3346',
  '--color-border-muted': '#3d465b',
  '--color-border-strong': '#596579',
  '--color-border-accent': '#4a556b',
  '--color-border-accent-strong': '#a864ff',
  '--color-border-accent-deep': '#d8c7ff',
  '--color-border-purple-muted': '#8f98ad',
  '--color-border-cool': '#3d465b',
  '--color-border-inverse': '#f4f6fb',
  '--color-divider': '#f4f6fb1f',
  '--color-shadow-soft': '#00000038',
  '--color-shadow-medium': '#00000073',
  '--color-shadow-strong': '#00000099',
  '--color-shadow-accent': '#a864ff33',
  '--color-shadow-inverse': '#ffffff80',
  '--color-control-bg': '#171b26',
  '--color-control-bg-hover': '#202637',
  '--color-control-bg-disabled': '#252c3e',
  '--color-control-bg-accent': '#202637',
  '--color-control-bg-accent-strong': '#4a2b61',
  '--color-control-border': '#3d465b',
  '--color-control-border-hover': '#596579',
  '--color-control-border-focus': '#a864ff',
  '--color-control-border-info': '#60a5fa',
  '--color-control-border-info-hover': '#93c5fd',
  '--color-control-border-focus-alt': '#a864ff',
  '--color-control-border-disabled': '#2b3346',
  '--color-control-text': '#f4f6fb',
  '--color-control-placeholder': '#8f98ad',
  '--color-control-check-bg': '#a864ff',
  '--color-control-check-info-bg': '#60a5fa',
  '--color-control-accent-deep': '#d8c7ff',
  '--color-control-accent-hover': '#a864ff',
  '--color-control-check-mark': '#ffffff',
  '--color-control-focus-ring': '#a864ff33',
  '--color-control-selection-bg': '#252c3e',
  '--color-control-selection-strong-bg': '#3a2f4d',
  '--color-icon-main': '#d7dce8',
  '--color-icon-secondary': '#94a3b8',
  '--color-icon-muted': '#6f788c',
  '--color-icon-faint': '#8f98ad',
  '--color-icon-accent': '#a864ff',
  '--color-icon-accent-strong': '#d8c7ff',
  '--color-icon-inverse': '#ffffff',
  '--color-icon-info': '#60a5fa',
  '--color-icon-bg': '#202637',
  '--color-icon-surface': '#3d4352',
  '--color-icon-border': '#676f84',
  '--color-icon-detail': '#747f98',
  '--color-icon-detail-muted': '#596176',
  '--color-icon-detail-soft': '#4c5365',
  '--color-icon-strong': '#b4bdd1',
  '--color-icon-accent-alt': '#a864ff',
  '--color-lavender-soft': '#202637',
  '--color-light-btn': '#202637',
  '--color-accent-btn': '#252c3e',
  '--color-button-primary-bg': '#9747ff',
  '--color-button-primary-hover-bg': '#7d3bea',
  '--color-button-primary-text': '#ffffff',
  '--color-button-primary-hover-text': '#ffffff',
  '--color-button-primary-active-text': '#ffffff',
  '--color-button-accent-alt-bg': '#a78bfa',
  '--color-button-accent-deep-bg': '#a78bfa',
  '--color-button-accent-muted-bg': '#b9a6ff',
  '--color-button-accent-muted-text': '#111827',
  '--color-button-accent-translucent-border': '#a78bfa66',
  '--color-button-accent-soft-bg': '#202637',
  '--color-button-pink-bg': '#5b3a58',
  '--color-button-secondary-bg': '#202637',
  '--color-button-secondary-soft-bg': '#202637',
  '--color-button-secondary-hover-bg': '#252c3e',
  '--color-button-secondary-pressed-bg': '#2b3346',
  '--color-button-secondary-text': '#f4f6fb',
  '--color-button-neutral-bg': '#1d2331',
  '--color-button-neutral-hover-bg': '#252c3e',
  '--color-button-neutral-text': '#f4f6fb',
  '--color-button-strong-text': '#f6f7fb',
  '--color-button-muted-bg': '#2b3346',
  '--color-button-cool-muted-bg': '#2b3346',
  '--color-button-neutral-pressed-bg': '#2b3346',
  '--color-button-border': '#3d465b',
  '--color-button-border-soft': '#3d465b',
  '--color-button-border-strong': '#4a556b',
  '--color-button-border-contrast': '#596579',
  '--color-button-border-hover': '#4a556b',
  '--color-button-lavender-border': '#d8c7ff',
  '--color-button-neutral-subtle-bg': '#252c3e',
  '--color-button-disabled-bg': '#252c3e',
  '--color-button-disabled-strong-bg': '#2b3346',
  '--color-button-disabled-text': '#6f788c',
  '--color-button-icon-muted': '#6f788c',
  '--color-button-icon-muted-hover': '#8f98ad',
  '--color-button-icon-disabled-soft': '#6f788c',
  '--color-button-danger-bg': '#ff7875',
  '--color-button-danger-hover-bg': '#ff9c99',
  '--color-button-danger-soft-bg': '#6b353a',
  '--color-button-danger-text': '#111827',
  '--color-button-danger-hover-text': '#111827',
  '--color-button-danger-strong-bg': '#ff7875',
  '--color-button-danger-strong-hover-bg': '#ff9c99',
  '--color-button-danger-legacy-bg': '#ff7875',
  '--color-button-danger-legacy-hover-bg': '#ff9c99',
  '--color-button-success-bg': '#4ade80',
  '--color-button-success-muted-bg': '#4ade80',
  '--color-button-info-bg': '#60a5fa',
  '--color-button-link-bg': '#60a5fa',
  '--color-button-link-text': '#111827',
  '--color-button-overlay-bg': '#25222eeb',
  '--color-button-vk-accent': '#0077ff',
  '--color-button-warning-bg': '#d8c7ff',
  '--color-button-warning-hover-bg': '#eadfff',
  '--color-button-warning-text': '#111827',
  '--color-button-focus-ring': '#a864ff',
  '--color-text-main': '#f4f6fb',
  '--color-text-secondary': '#d7dce8',
  '--color-text-muted': '#94a3b8',
  '--color-text-strong': '#f4f6fb',
  '--color-text-strong-secondary': '#d7dce8',
  '--color-text-neutral': '#cbd1dd',
  '--color-text-neutral-soft': '#aeb7c9',
  '--color-text-soft': '#94a3b8',
  '--color-text-gray': '#aeb7c9',
  '--color-text-placeholder': '#8f98ad',
  '--color-text-disabled': '#6f788c',
  '--color-text-pale': '#d7dce8',
  '--color-text-faint': '#f4f6fb3f',
  '--color-text-dimmed': '#f4f6fb80',
  '--color-text-translucent': '#f4f6fbb3',
  '--color-text-inverse-soft': '#eef3ff',
  '--color-text-on-accent-muted': '#ffffffb6',
  '--color-text-accent': '#c084fc',
  '--color-text-accent-strong': '#a78bfa',
  '--color-text-accent-muted': '#c084fca8',
  '--color-text-info': '#60a5fa',
  '--color-text-success': '#4ade80',
  '--color-text-danger': '#f87171',
  '--color-text-warning': '#fbbf24',
  '--color-text-lavel-status': '#8f98ad',
  '--color-text-lavel': '#dce4ff',
  '--color-violet': '#b9a6ef',
  '--color-violet-dark': '#c6b5f5',
  '--color-time': '#bfa8ce',
  '--color-link-blue': '#69b1ff',
  '--color-page-bg': '#0f131c',
  '--color-surface': '#171b26',
  '--color-surface-soft': '#1d2331',
  '--color-surface-subtle': '#151a25',
  '--color-surface-muted': '#202637',
  '--color-surface-panel': '#1c2230',
  '--color-surface-cool': '#283044',
  '--color-surface-cool-soft': '#202637',
  '--color-surface-accent': '#202637',
  '--color-surface-accent-soft': '#202637',
  '--color-surface-accent-muted': '#252c3e',
  '--color-surface-table-accent': '#202637',
  '--color-surface-canvas': '#171c28',
  '--color-surface-deep': '#151c2b',
  '--color-surface-deepest': '#111827',
  '--color-surface-auth': '#08101c',
  '--color-surface-overlay': '#171b26e6',
  '--color-surface-overlay-soft': '#171b268c',
  '--color-surface-image-scrim': '#020a0c6b',
  '--color-surface-backdrop': '#05070bb8',
  '--color-surface-backdrop-soft': '#05070b8f',
  '--task-tracker-surface-muted': '#1d2331',
  '--task-tracker-surface-overlay': '#1d2331e6',
  '--task-tracker-surface-overlay-soft': '#1d23319e',
  '--task-tracker-accent-overlay': '#9747ff29',
  '--task-tracker-border-accent': '#5b4b82',
  '--task-tracker-text-muted': '#94a3b8',
  '--task-tracker-danger': '#ff7875',
  '--task-tracker-danger-bg': '#ff78752e',
  '--task-tracker-danger-border': '#ff787561',
  '--task-tracker-warning': '#f59e0b',
  '--task-tracker-warning-bg': '#f59e0b29',
  '--task-tracker-warning-border': '#f59e0b57',
  '--task-tracker-info-bg': '#69b1ff24',
  '--task-tracker-info': '#69b1ff',
}

export const DEFAULT_PLATFORM_THEME_COLORS = {
  light: LIGHT_THEME_COLORS,
  dark: {
    ...LIGHT_THEME_COLORS,
    ...DARK_THEME_OVERRIDES,
  },
}

const COLOR_VARIABLES = PLATFORM_THEME_COLOR_GROUPS.flatMap((group) =>
  group.colors.map(([variable]) => variable),
)

export const PLATFORM_THEME_COLOR_LABELS = PLATFORM_THEME_COLOR_GROUPS.reduce(
  (labels, group) => {
    group.colors.forEach(([variable, title]) => {
      labels[variable] = title
    })

    return labels
  },
  {},
)

// В интерфейсе редактируются базовые цвета, а связанные legacy-токены
// пересчитываются автоматически. Полный список выше сохраняется для
// обратной совместимости со старыми настройками и существующими стилями.
export const PLATFORM_THEME_PALETTE_GROUPS = [
  {
    title: 'Бренд и действия',
    colors: [
      {
        variable: '--color-accent',
        title: 'Фирменный цвет',
        description:
          'Главный акцент платформы и его состояния: обычное, наведение, нажатие и фокус.',
        examples:
          'Основные кнопки, активные вкладки, чекбоксы, ссылки и выделенные пункты меню.',
        targets: [
          '--color-accent-bright',
          '--color-accent-vivid',
          '--color-violet',
          '--color-violet-dark',
          '--color-button-primary-bg',
          '--color-button-primary-hover-bg',
          '--color-button-accent-alt-bg',
          '--color-button-accent-deep-bg',
          '--color-button-accent-muted-bg',
          '--color-button-accent-muted-text',
          '--color-button-accent-translucent-border',
          '--color-button-focus-ring',
          '--color-border-accent',
          '--color-border-accent-strong',
          '--color-border-accent-deep',
          '--color-border-purple-muted',
          '--color-stroke-hover',
          '--color-control-border-focus',
          '--color-control-border-focus-alt',
          '--color-control-check-bg',
          '--color-control-accent-deep',
          '--color-control-accent-hover',
          '--color-control-focus-ring',
          '--color-icon-accent',
          '--color-icon-accent-strong',
          '--color-icon-accent-alt',
          '--color-text-accent',
          '--color-text-accent-strong',
          '--color-text-accent-muted',
          '--color-shadow-accent',
          '--task-tracker-accent-overlay',
          '--task-tracker-border-accent',
        ],
      },
      {
        variable: '--color-on-accent',
        title: 'Текст на фирменном фоне',
        description:
          'Контрастный цвет текста и значков поверх фирменных заливок.',
        examples:
          'Надписи основных кнопок, галочки выбранных чекбоксов и белые иконки.',
        targets: [
          '--color-button-primary-text',
          '--color-button-primary-hover-text',
          '--color-button-primary-active-text',
          '--color-control-check-mark',
          '--color-border-inverse',
          '--color-icon-inverse',
          '--color-text-inverse-soft',
          '--color-text-on-accent-muted',
        ],
      },
      {
        variable: '--color-surface-accent',
        title: 'Светлый фирменный фон',
        description:
          'Мягкие фирменные заливки и вторичные состояния без изменения основного фона страниц.',
        examples:
          'Вторичные кнопки, выбранные строки, плашки, табы и подсвеченные карточки.',
        targets: [
          '--color-lavender-soft',
          '--color-light-btn',
          '--color-accent-btn',
          '--color-button-accent-soft-bg',
          '--color-button-pink-bg',
          '--color-button-secondary-bg',
          '--color-button-secondary-soft-bg',
          '--color-button-secondary-hover-bg',
          '--color-button-secondary-pressed-bg',
          '--color-surface-accent-soft',
          '--color-surface-accent-muted',
          '--color-surface-table-accent',
          '--color-control-bg-accent',
          '--color-control-bg-accent-strong',
          '--color-control-selection-bg',
          '--color-control-selection-strong-bg',
          '--color-button-lavender-border',
        ],
      },
    ],
  },
  {
    title: 'Текст',
    colors: [
      {
        variable: '--color-text-main',
        title: 'Основной текст',
        description:
          'Самый контрастный текст интерфейса и подписи активных элементов.',
        examples: 'Заголовки, значения в таблицах, названия разделов и полей.',
        targets: [
          '--color-text-strong',
          '--color-text-strong-secondary',
          '--text-active',
          '--color-black',
          '--color-dark',
          '--color-control-text',
          '--color-button-secondary-text',
          '--color-button-neutral-text',
          '--color-button-strong-text',
          '--color-status-neutral-strong-bg',
          '--color-text-lavel',
        ],
      },
      {
        variable: '--color-text-secondary',
        title: 'Дополнительный текст',
        description:
          'Текст второго уровня, который должен быть заметен, но не спорить с заголовками.',
        examples:
          'Описания блоков, подписи фильтров, пояснения в карточках и вторичные значения.',
        targets: [
          '--color-text-neutral',
          '--color-text-neutral-soft',
          '--color-text-soft',
          '--color-text-gray',
          '--color-text-translucent',
          '--color-text-lavel-status',
          '--color-time',
          '--color-icon-secondary',
        ],
      },
      {
        variable: '--color-text-muted',
        title: 'Приглушённый текст',
        description:
          'Слабоконтрастные подписи, подсказки и неактивные состояния.',
        examples:
          'Placeholder полей, даты, служебные подписи и отключённые кнопки.',
        targets: [
          '--color-gray',
          '--color-text-placeholder',
          '--color-text-disabled',
          '--color-text-pale',
          '--color-text-faint',
          '--color-text-dimmed',
          '--color-control-placeholder',
          '--color-button-disabled-text',
          '--color-status-neutral-text',
          '--task-tracker-text-muted',
        ],
      },
    ],
  },
  {
    title: 'Фоны и поверхности',
    colors: [
      {
        variable: '--color-page-bg',
        title: 'Фон страницы',
        description:
          'Базовый фон рабочего пространства за карточками и таблицами.',
        examples: 'Главная страница, журнал, отчёты и страницы профиля.',
        targets: ['--color-surface-canvas'],
      },
      {
        variable: '--color-surface',
        title: 'Карточки и модальные окна',
        description:
          'Основная поверхность контентных блоков, всплывающих окон и белых панелей.',
        examples:
          'Карточки, модальные окна, выпадающие списки и шапка платформы.',
        targets: [
          '--color-white',
          '--color-surface-deep',
          '--color-surface-auth',
          '--color-surface-overlay',
          '--color-surface-overlay-soft',
          '--color-button-overlay-bg',
          '--color-icon-surface',
          '--task-tracker-surface-overlay',
          '--task-tracker-surface-overlay-soft',
        ],
      },
      {
        variable: '--color-surface-muted',
        title: 'Нейтральный серый фон',
        description:
          'Единый базовый цвет для всех нейтральных серых поверхностей; светлые и тёмные варианты рассчитываются автоматически.',
        examples:
          'Фильтры, подложки таблиц, неактивные блоки, серые кнопки и пустые состояния.',
        targets: [
          '--color-smoke',
          '--color-light-grey-nd',
          '--color-mid-grey-nd',
          '--color-grey-nd',
          '--color-blue-gray',
          '--color-surface-soft',
          '--color-surface-subtle',
          '--color-surface-panel',
          '--color-surface-cool',
          '--color-surface-cool-soft',
          '--color-surface-deepest',
          '--color-button-muted-bg',
          '--color-button-cool-muted-bg',
          '--color-button-neutral-subtle-bg',
          '--color-button-disabled-bg',
          '--color-button-disabled-strong-bg',
          '--color-status-neutral-bg',
          '--color-icon-bg',
          '--task-tracker-surface-muted',
        ],
      },
      {
        variable: '--color-control-bg',
        title: 'Фон полей и нейтральных кнопок',
        description:
          'Заливка элементов ввода и обычных кнопок; состояния hover и disabled рассчитываются автоматически.',
        examples: 'Input, select, поиск, белые кнопки и элементы выбора.',
        targets: [
          '--color-control-bg-hover',
          '--color-control-bg-disabled',
          '--color-button-neutral-bg',
          '--color-button-neutral-hover-bg',
          '--color-button-neutral-pressed-bg',
        ],
      },
    ],
  },
  {
    title: 'Границы, тени и иконки',
    colors: [
      {
        variable: '--color-border-neutral',
        title: 'Границы и разделители',
        description:
          'Основной цвет линий; более мягкие и контрастные варианты рассчитываются автоматически.',
        examples:
          'Границы карточек и полей, строки таблиц, разделители и контуры кнопок.',
        targets: [
          '--color-light-stroke',
          '--color-border-soft',
          '--color-border-subtle',
          '--color-border-muted',
          '--color-border-strong',
          '--color-border-cool',
          '--color-divider',
          '--color-control-border',
          '--color-control-border-hover',
          '--color-control-border-disabled',
          '--color-button-border',
          '--color-button-border-soft',
          '--color-button-border-strong',
          '--color-button-border-contrast',
          '--color-button-border-hover',
          '--color-icon-border',
          '--color-icon-detail',
        ],
      },
      {
        variable: '--color-shadow-medium',
        title: 'Тени и затемнение',
        description:
          'Интенсивность теней и затемняющих подложек; прозрачность вариантов сохраняется.',
        examples:
          'Модальные окна, выпадающие списки, tooltip и затемнение страницы.',
        targets: [
          '--color-shadow-soft',
          '--color-shadow-strong',
          '--color-shadow-inverse',
          '--color-surface-backdrop',
          '--color-surface-backdrop-soft',
          '--color-surface-image-scrim',
        ],
      },
      {
        variable: '--color-icon-main',
        title: 'Основные иконки',
        description: 'Контрастные иконки основных действий и навигации.',
        examples: 'Иконки в шапке, кнопках, таблицах и активных пунктах меню.',
        targets: ['--color-icon-strong'],
      },
      {
        variable: '--color-icon-muted',
        title: 'Приглушённые иконки',
        description: 'Вторичные, декоративные и неактивные иконки.',
        examples:
          'Неактивное меню, служебные значки, стрелки и иконки подсказок.',
        targets: [
          '--color-icon-faint',
          '--color-icon-detail-muted',
          '--color-icon-detail-soft',
          '--color-button-icon-muted',
          '--color-button-icon-muted-hover',
          '--color-button-icon-disabled-soft',
        ],
      },
    ],
  },
  {
    title: 'Статусы',
    colors: [
      {
        variable: '--color-status-success',
        title: 'Успех',
        description: 'Основной цвет успешных и подтверждённых состояний.',
        examples:
          'Успешное сохранение, активный статус, выполненная работа и положительные метки.',
        targets: [
          '--color-green',
          '--color-green-deep',
          '--color-success',
          '--color-success-soft',
          '--color-status-success-bg',
          '--color-status-success-border',
          '--color-status-success-text',
          '--color-text-success',
          '--color-button-success-bg',
          '--color-button-success-muted-bg',
        ],
      },
      {
        variable: '--color-status-warning',
        title: 'Предупреждение',
        description: 'Цвет предупреждений и состояний, требующих внимания.',
        examples:
          'Предупреждающие уведомления, ожидание проверки и важные метки.',
        targets: [
          '--color-yellow',
          '--color-yellow-deep',
          '--color-status-warning-bg',
          '--color-status-warning-border',
          '--color-status-warning-text',
          '--color-text-warning',
          '--color-button-warning-bg',
          '--color-button-warning-hover-bg',
          '--color-button-warning-text',
          '--task-tracker-warning',
          '--task-tracker-warning-bg',
          '--task-tracker-warning-border',
        ],
      },
      {
        variable: '--color-status-danger',
        title: 'Ошибка и опасное действие',
        description: 'Цвет ошибок, удалений и критичных состояний.',
        examples: 'Ошибки формы, удаление, просрочка и отрицательные статусы.',
        targets: [
          '--color-accent-first',
          '--color-red',
          '--color-pink-deep',
          '--color-danger',
          '--color-danger-soft',
          '--color-status-danger-bg',
          '--color-status-danger-border',
          '--color-status-danger-text',
          '--color-text-danger',
          '--color-button-danger-bg',
          '--color-button-danger-hover-bg',
          '--color-button-danger-soft-bg',
          '--color-button-danger-text',
          '--color-button-danger-hover-text',
          '--color-button-danger-strong-bg',
          '--color-button-danger-strong-hover-bg',
          '--color-button-danger-legacy-bg',
          '--color-button-danger-legacy-hover-bg',
          '--task-tracker-danger',
          '--task-tracker-danger-bg',
          '--task-tracker-danger-border',
        ],
      },
      {
        variable: '--color-status-info-text',
        title: 'Информация и ссылки',
        description: 'Информационные состояния и интерактивные ссылки.',
        examples:
          'Информационные плашки, ссылки, справочные сообщения и синие действия.',
        targets: [
          '--color-accent-second',
          '--color-blue-deep',
          '--color-link-blue',
          '--color-status-info-bg',
          '--color-status-info-border',
          '--color-text-info',
          '--color-button-info-bg',
          '--color-button-link-bg',
          '--color-button-link-text',
          '--color-control-border-info',
          '--color-control-border-info-hover',
          '--color-control-check-info-bg',
          '--color-icon-info',
          '--task-tracker-info',
          '--task-tracker-info-bg',
        ],
      },
    ],
  },
]

const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

const normalizeHex = (value) => {
  let hex = String(value || '')
    .trim()
    .slice(1)

  if (hex.length === 3 || hex.length === 4) {
    hex = hex
      .split('')
      .map((item) => item + item)
      .join('')
  }

  return hex.length === 6 ? `${hex}ff` : hex
}

const hexToHsla = (value) => {
  const hex = normalizeHex(value)
  const [red, green, blue] = [0, 2, 4].map(
    (index) => parseInt(hex.slice(index, index + 2), 16) / 255,
  )
  const alpha = parseInt(hex.slice(6, 8), 16) / 255
  const max = Math.max(red, green, blue)
  const min = Math.min(red, green, blue)
  const delta = max - min
  const lightness = (max + min) / 2
  let hue = 0

  if (delta) {
    if (max === red) hue = ((green - blue) / delta) % 6
    else if (max === green) hue = (blue - red) / delta + 2
    else hue = (red - green) / delta + 4

    hue *= 60
    if (hue < 0) hue += 360
  }

  const saturation = delta ? delta / (1 - Math.abs(2 * lightness - 1)) : 0

  return { hue, saturation, lightness, alpha }
}

const hslaToHex = ({ hue, saturation, lightness, alpha }) => {
  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation
  const sector = (((hue % 360) + 360) % 360) / 60
  const offset = chroma * (1 - Math.abs((sector % 2) - 1))
  let channels = [0, 0, 0]

  if (sector < 1) channels = [chroma, offset, 0]
  else if (sector < 2) channels = [offset, chroma, 0]
  else if (sector < 3) channels = [0, chroma, offset]
  else if (sector < 4) channels = [0, offset, chroma]
  else if (sector < 5) channels = [offset, 0, chroma]
  else channels = [chroma, 0, offset]

  const match = lightness - chroma / 2
  const toHex = (channel) =>
    Math.round(clamp(channel + match, 0, 1) * 255)
      .toString(16)
      .padStart(2, '0')
  const color = `#${channels.map(toHex).join('')}`
  const alphaHex = Math.round(clamp(alpha, 0, 1) * 255)
    .toString(16)
    .padStart(2, '0')

  return alphaHex === 'ff' ? color : `${color}${alphaHex}`
}

const getHueDelta = (target, source) => ((target - source + 540) % 360) - 180

const derivePaletteShade = (value, sourceDefault, targetDefault) => {
  const source = hexToHsla(sourceDefault)
  const target = hexToHsla(targetDefault)
  const next = hexToHsla(value)

  return hslaToHex({
    hue: next.hue + getHueDelta(target.hue, source.hue),
    saturation: clamp(
      next.saturation + target.saturation - source.saturation,
      0,
      1,
    ),
    lightness: clamp(
      next.lightness + target.lightness - source.lightness,
      0,
      1,
    ),
    alpha: clamp(
      source.alpha ? (target.alpha / source.alpha) * next.alpha : target.alpha,
      0,
      1,
    ),
  })
}

export const getPlatformThemePaletteUpdates = (paletteColor, value, theme) => {
  if (!paletteColor?.variable) return {}

  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase()
  if (!isHexColor(normalizedValue)) {
    return { [paletteColor.variable]: value }
  }

  const defaults = DEFAULT_PLATFORM_THEME_COLORS[theme]
  const sourceDefault = defaults?.[paletteColor.variable]
  if (!sourceDefault) return { [paletteColor.variable]: normalizedValue }

  return [paletteColor.variable, ...(paletteColor.targets || [])].reduce(
    (result, variable) => {
      const targetDefault = defaults[variable]
      if (!targetDefault) return result

      result[variable] =
        variable === paletteColor.variable
          ? normalizedValue
          : derivePaletteShade(normalizedValue, sourceDefault, targetDefault)
      return result
    },
    {},
  )
}

export const isHexColor = (value) =>
  /^#(?:[\da-f]{3}|[\da-f]{4}|[\da-f]{6}|[\da-f]{8})$/i.test(
    String(value || '').trim(),
  )

const parseSetting = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    return JSON.parse(value)
  } catch {
    return {}
  }
}

export const normalizePlatformThemeColorOverrides = (value) => {
  const parsed = parseSetting(value)

  return ['light', 'dark'].reduce((result, theme) => {
    const source = parsed?.[theme]
    result[theme] = {}

    if (!source || typeof source !== 'object') return result

    COLOR_VARIABLES.forEach((variable) => {
      if (isHexColor(source[variable])) {
        result[theme][variable] = source[variable].toLowerCase()
      }
    })

    return result
  }, {})
}

export const getPlatformThemeColors = (value, theme) => ({
  ...DEFAULT_PLATFORM_THEME_COLORS[theme],
  ...normalizePlatformThemeColorOverrides(value)[theme],
})

export const buildPlatformThemeColorOverrides = (colors) =>
  ['light', 'dark'].reduce((result, theme) => {
    result[theme] = {}

    COLOR_VARIABLES.forEach((variable) => {
      const value = String(colors?.[theme]?.[variable] || '').toLowerCase()
      if (
        isHexColor(value) &&
        value !== DEFAULT_PLATFORM_THEME_COLORS[theme][variable]
      ) {
        result[theme][variable] = value
      }
    })

    return result
  }, {})

const getAccentRgb = (color) => {
  let value = color.slice(1)
  if (value.length === 3 || value.length === 4) {
    value = value
      .slice(0, 3)
      .split('')
      .map((item) => item + item)
      .join('')
  }

  return [0, 2, 4]
    .map((index) => parseInt(value.slice(index, index + 2), 16))
    .join(', ')
}

export const applyPlatformThemeColors = (setting, theme) => {
  if (typeof document === 'undefined') return

  const rootStyle = document.documentElement.style
  const overrides = normalizePlatformThemeColorOverrides(setting)[theme]

  COLOR_VARIABLES.forEach((variable) => rootStyle.removeProperty(variable))
  rootStyle.removeProperty('--color-accent_rgb')

  Object.entries(overrides).forEach(([variable, value]) => {
    rootStyle.setProperty(variable, value)
  })

  const accent =
    overrides['--color-accent'] ||
    DEFAULT_PLATFORM_THEME_COLORS[theme]['--color-accent']
  rootStyle.setProperty('--color-accent_rgb', getAccentRgb(accent))
}

export const notifyPlatformThemeColorsChange = (value) => {
  if (typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent(PLATFORM_THEME_COLORS_CHANGE_EVENT, {
      detail: { value },
    }),
  )
}
